export default {
    page_title: "Kevi | Relatório de Retenção",
    title: "Relatório de Retenção",
    filters: {
        client_segment: "Segmento do cliente",
    },
    common: {
        in: "em",
        between: "entre",
        and: "e",
    },
    stats: {
        average_ticket: "Ticket médio",
        average_lifetime: "Tempo médio de vida",
        average_lifetime_suffix: "Meses",
        average_orders_per_client: "Por cliente em média",
        average_orders_suffix: "Pedidos",
        projected_ltv: "LTV Projetado",
    },
    cohort: {
        action_label: "Ação",
        segment_label: "Segmento",
        select_segment: "Selecione um segmento",
        view_by: "Visualizar safra por:",
        view_period: "Período",
        view_orders: "Número de pedidos",
        interval_label: "Intervalo",
        interval_daily: "Diário",
        interval_weekly: "Semanal",
        interval_monthly: "Mensal",
        interval_yearly: "Anual",
        action_order: "Fez pedido",
        action_joined_segment: "Entrou no Segmento",
        action_left_segment: "Saiu do Segmento",
        no_data: "Nenhum dado disponível para exibir",
    },
    clients: {
        title: "Clientes",
        cohort: "Safra",
        action: "Ação",
        action_order: "compraram",
        action_joined_segment: "entraram no segmento",
        action_left_segment: "saíram do segmento",
        times_singular: "vez",
        times_plural: "vezes",
        times_or_more: "ou mais",
        years_old_suffix: "anos",
        not_informed: "Não informada",
        details_button: "Detalhes",
    },
    grid: {
        name: "Nome",
        phone: "Telefone",
        birthday: "Aniversário",
        average_ticket: "Ticket Médio (R$)",
        total_spent: "R$ Gastos",
        total_orders: "Pedidos Feitos",
        email: "E-mail",
    },
};
